import React from 'react';
import { Box, Button, Tooltip } from '@material-ui/core';
import { Link } from '@backstage/core-components';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  tabContainer: {
    display: 'flex',
    gap: '8px',
    backgroundColor: '#f9fafb',
    padding: '6px',
    borderRadius: '8px',
    border: '1px solid #e5e7eb',
    overflow: 'auto',
    flexShrink: 1,
    minWidth: '200px',
  },
  tabButton: {
    textTransform: 'none',
    fontWeight: 'bold',
    fontSize: '14px',
    padding: '10px 24px',
    borderRadius: '6px',
    backgroundColor: 'transparent',
    color: '#9ca3af',
    minWidth: 'auto',
    whiteSpace: 'nowrap',
    transition: 'all 0.2s',
    border: 'none',
    '&:hover': {
      backgroundColor: 'rgba(255,255,255,0.5)',
      color: '#111827',
    },
  },
  tabButtonDisabled: {
    opacity: 0.4,
    cursor: 'not-allowed !important',
    // pointerEvents: 'auto',
    '&:hover': {
      backgroundColor: 'transparent',
      color: '#9ca3af',
    },
  },
  tabButtonActive: {
    backgroundColor: '#ffffff',
    color: '#111827',
    fontWeight: 'bold',
    boxShadow:
      '0 4px 6px -1px rgba(0,0,0,0.1), 0 2px 4px -1px rgba(0,0,0,0.06)',
    border: '1px solid #e5e7eb',
    '&:hover': {
      backgroundColor: '#ffffff',
      color: '#111827',
    },
  },
});

interface Tab {
  id: string;
  label: string;
  onClick: () => void;
  disabled?: boolean;
  showTooltip?: boolean;
}

interface TabNavigationProps {
  tabs: Tab[];
  activeTab: string;
}

export const TabNavigation: React.FC<TabNavigationProps> = ({
  tabs,
  activeTab,
}) => {
  const classes = useStyles();

  return (
    <Box className={classes.tabContainer}>
      {tabs.map(tab =>
        tab.disabled && tab.showTooltip !== false ? (
          <Tooltip
            key={tab.id}
            title={
              <>
                You don't have access to this screen.{' '}
                <Link
                  to="/marketplace/request-access"
                  style={{ color: '#60a5fa', textDecoration: 'underline' }}
                >
                  Request Access
                </Link>
              </>
            }
            arrow
            interactive
            enterDelay={200}
          >
            <span>
              <Button
                className={`${classes.tabButton} ${
                  tab.disabled ? classes.tabButtonDisabled : ''
                }`}
              >
                {tab.label}
              </Button>
            </span>
          </Tooltip>
        ) : tab.disabled ? (
          <Button
            key={tab.id}
            className={`${classes.tabButton} ${classes.tabButtonDisabled}`}
          >
            {tab.label}
          </Button>
        ) : (
          <Button
            key={tab.id}
            className={`${classes.tabButton} ${
              activeTab === tab.id ? classes.tabButtonActive : ''
            }`}
            onClick={tab.onClick}
            disableRipple
          >
            {tab.label}
          </Button>
        ),
      )}
    </Box>
  );
};
